import { useExperienceMasterDataApi } from "@/composables/useExperienceMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useExperienceInterestsMasterdataQuery() {
  const experienceMasterDataApi = useExperienceMasterDataApi();
  return useQuery({
    queryKey: ["experience-interests-masterdata"],
    queryFn: () => experienceMasterDataApi.getInterests(),
    select: ({ data }) => data,
  });
}
